/**
 * Class represents session DB for saving instances
 */
class DB {
    constructor() {
        // Create DB if not exists
        if (!window.db) {
            window.db = {};
        }
    }

    /**
     * Save instance record to DB.
     * @param {string} collectionName - instance class name.
     * @param {object} instance - instance to save.
     */
    static save(collectionName, instance) {
        instance.setProp('dbCollection', collectionName);

        if (window.db[collectionName]) {
            window.db[collectionName].push(instance);
        } else {
            window.db[collectionName] = [instance];
        }
    }

    /**
     * Get instance record from DB.
     * @param {string} id - instance record ID
     */
    static get(id, collectionName = null) {
        if (collectionName) {
            return window.db[collectionName].find(instance => instance._id === id);
        }

        const collections = Object.keys(window.db);

        for (let i = 0; i < collections.length; i++) {
            return window.db[collections[i]].find(instance => instance._id === id);
        }

        return undefined;
    }

    /**
     * Delete instance record from DB.
     * @param {string} id - instance record ID
     */
    static delete(id, collectionName = null) {
        const instance = DB.get(id, collectionName);

        if (instance) {
            const collection = instance.getProp('dbCollection');
            window.db[collection] = window.db[collection].filter(item => item._id !== instance._id);
        }
    }

    /**
     * Clear all DB records.
     */
    static clear() {
        window.db = {};
    }
}

// Create DB instance
const db = new DB();

export default DB;
